import React, { useState } from 'react';
import { Truck } from 'lucide-react';
import PhotoCapture from './PhotoCapture';
import TrustBadge from './TrustBadge';

const DriverView = ({ data, save, user, addNotification }) => {
  const [sel, setSel] = useState(null);
  const [photo, setPhoto] = useState(null);

  const confirm = () => {
    if (!photo) {
      alert('Vehicle photo required');
      return;
    }
    const updated = {
      ...sel,
      status: 'in_transit',
      departurePhoto: photo,
      departedAt: new Date().toISOString()
    };
    save('dispatches', data.dispatches.map(d => d.id === sel.id ? updated : d));
    addNotification('Departure Confirmed', `${sel.productName} now in transit`, 'info');
    alert('✅ Departure confirmed');
    setSel(null);
    setPhoto(null);
  };

  const mine = data.dispatches.filter(d =>
    d.status === 'approved' && d.driver === user.name
  );
  const allApproved = data.dispatches.filter(d => d.status === 'approved');
  const displayList = mine.length > 0 ? mine : allApproved;

  if (sel) {
    return (
      <div className="space-y-4">
        <h2 className="text-2xl font-bold">Confirm Departure</h2>
        <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
          <p className="font-bold text-lg">{sel.productName}</p>
          <p className="text-sm text-gray-600">Vehicle: {sel.vehicle}</p>
          <p className="text-sm text-gray-600">Qty: {sel.quantity}</p>
          <p className="text-sm text-gray-600">ETA: {new Date(sel.expectedDelivery).toLocaleString()}</p>
        </div>
        <PhotoCapture label="Loaded vehicle photo *" onCapture={setPhoto} />
        <div className="flex gap-3">
          <button onClick={() => { setSel(null); setPhoto(null); }} className="flex-1 bg-gray-200 p-3 rounded-lg font-semibold">Cancel</button>
          <button onClick={confirm} className="flex-1 bg-blue-600 text-white p-3 rounded-lg font-bold">Confirm Departure</button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-bold">Driver</h2>
        <TrustBadge score={user.trustScore} />
      </div>
      <h3 className="font-semibold text-gray-700">
        {mine.length > 0 ? 'My Assigned Deliveries' : 'All Approved Deliveries'}
      </h3>
      {displayList.length === 0 ? (
        <div className="text-center py-12">
          <Truck className="w-16 h-16 text-gray-300 mx-auto mb-3" />
          <p className="text-gray-500">No deliveries assigned yet</p>
        </div>
      ) : (
        displayList.map(d => (
          <div
            key={d.id}
            onClick={() => setSel(d)}
            className="border-2 p-4 rounded-lg cursor-pointer hover:border-blue-500 hover:bg-blue-50 transition-all"
          >
            <p className="font-bold">{d.productName}</p>
            <p className="text-sm text-gray-600">Vehicle: {d.vehicle} • Driver: {d.driver}</p>
            <p className="text-sm text-gray-600">ETA: {new Date(d.expectedDelivery).toLocaleString()}</p>
            <p className="text-xs text-blue-600 mt-2 font-semibold">Tap to confirm departure →</p>
          </div>
        ))
      )}
    </div>
  );
};

export default DriverView;
